import { NavConfig } from '@/types/header'
import { Star } from 'lucide-react'

export const navConfig: NavConfig = {
  NAM: {
    href: '/nam',
    sections: [
      {
        title: 'Tất cả sản phẩm',
        href: '/collection/do-nam',
        items: [
          {
            title: 'Sản phẩm mới',
            href: '/collection/san-pham-moi?gender_type=MALE',
            className: 'text-primary font-semibold',
          },
          // {
          //   title: 'Giá tốt <199k',
          //   href: '/collection/gia-tot-nhat',
          //   className: 'font-semibold text-secondary hover:text-primary-500',
          // },
          {
            title: 'Bán chạy nhất',
            href: '/collection/ban-chay-nhat?gender_type=MALE',
            className: 'font-semibold text-neutral-900 hover:text-primary-500',
          },
          { title: 'ECC Collection', href: '/collection/ecc-collection' },
          { title: 'Excool Collection', href: '/collection/excool' },
          {
            title: 'Copper Denim',
            href: '/collection/copper-denim',
          },
          {
            title: 'Promax',
            href: '/collection/ldp-promax?itm_source=navbar',
          },
        ],
      },
      {
        title: 'ÁO NAM',
        href: '/collection/ao-nam',
        items: [
          { title: 'Áo Tanktop', href: '/collection/ao-ba-lo-tank-top-nam' },
          { title: 'Áo thun', href: '/collection/ao-thun-nam' },
          {
            title: 'Áo Thể Thao',
            href: '/collection/ao-nam-choi-the-thao',
          },
          { title: 'Áo Polo', href: '/collection/ao-polo-nam' },
          { title: 'Áo Sơ Mi', href: '/collection/ao-so-mi-nam' },
          { title: 'Áo Dài Tay', href: '/collection/ao-nam-dai-tay' },
          { title: 'Áo Khoác', href: '/collection/ao-khoac-nam' },
          { title: 'Áo thun Graphic', href: '/graphic-tee?itm_source=navbar' },
        ],
      },
      {
        title: 'QUẦN NAM',
        href: '/collection/quan-nam',
        items: [
          // { title: 'Quần Nam', href: '/collection/quan-nam' },
          { title: 'Quần Short', href: '/collection/quan-short-nam' },
          { title: 'Quần Jogger', href: '/collection/quan-jogger-nam' },
          {
            title: 'Quần Thể Thao',
            href: '/collection/quan-nam-choi-the-thao',
          },
          { title: 'Quần Dài', href: '/collection/quan-dai-nam' },
          { title: 'Quần Jean', href: '/collection/quan-jeans-nam' },
          { title: 'Quần Kaki', href: '/collection/quan-kaki-nam' },
          { title: 'Quần Pants', href: '/collection/quan-pants-nam' },
          { title: 'Quần Bơi', href: '/collection/do-boi-nam' },
        ],
      },
      {
        title: 'QUẦN LÓT NAM',
        href: '/collection/quan-lot-nam',
        items: [
          // { title: 'Quần lót nam', href: '/collection/quan-lot-nam' },
          {
            title: 'Brief (Tam giác)',
            href: '/collection/quan-lot-nam-brief-tam-giac',
          },
          {
            title: 'Trunk (Boxer)',
            href: '/collection/quan-lot-nam-boxer-trunk',
          },
          {
            title: 'Boxer Brief (Boxer dài)',
            href: '/collection/quan-lot-nam-brief-boxer-dang-dai',
          },
          { title: 'Long Leg', href: '/collection/quan-lot-nam-long-leg' },
          {
            title: 'Short mặc nhà',
            href: '/collection/quan-short-nam-mac-o-nha',
          },
        ],
      },
      {
        title: 'PHỤ KIỆN',
        href: '/collection/phu-kien-nam',
        items: [
          {
            title: 'Tất cả phụ kiện',
            description: '(Tất, mũ, túi...)',
            href: '/collection/phu-kien-nam',
          },
        ],
      },
    ],
    featured: [
      {
        title: 'Pickleball Nam',
        href: '/collection/pickleball-tennis?danh-muc-san-pham=pickleball-nam',
        imageAlt: 'Pickleball Nam',
        imageSrc: '/image/June2025/mceclip9_63.jpg',
      },
      {
        title: 'Quần Jeans Nam siêu nhẹ',
        href: '/product/quan-jeans-nam-dang-straight-sieu-nhe?color=xanh-wash',
        imageAlt: 'Quần Jeans Nam siêu nhẹ',
        imageSrc: '/image/March2025/mceclip23.png',
      },
    ],
    footer: [
      {
        title: 'Theo nhu cầu',
        items: [
          {
            title: 'ĐỒ LÓT',
            href: '/collection/quan-lot-nam',
          },
          {
            title: 'ĐỒ THỂ THAO',
            href: '/collection/coolmate-activewear',
          },
          {
            title: 'MẶC HÀNG NGÀY',
            href: '/collection/do-casual',
          },
        ],
      },
    ],
    // mobileBanner: {
    //   title: 'Quần Dài Nam Kaki Excool',
    //   href: '/products/quan-dai-kaki-excool',
    //   imageAlt: 'sadasd',
    //   imageSrc:
    //     'https://media3.coolmate.me/cdn-cgi/image/quality=80,format=auto/uploads/March2025/mceclip24.png',
    // },
  },
  NỮ: {
    href: '/nu',
    sections: [
      {
        title: 'TẤT CẢ SẢN PHẨM',
        href: '/collection/coolmate-activewear-nu',
        items: [
          { title: 'Chạy bộ', href: '/collection/quan-ao-chay-bo-nu' },
          { title: 'Yoga & Pilates', href: '/collection/yoga-pilates' },
          { title: 'Thể thao chung', href: '/collection/the-thao-chung-nu' },
          {
            title: 'Pickleball',
            href: '/collection/pickleball-tennis?danh-muc-san-pham=pickleball-nu&itm_source=navbar',
          },
          {
            title: 'Cầu lông & Bóng bàn',
            href: '/collection/cau-long-bong-ban-nu',
            isComingSoon: true,
          },
        ],
      },
      {
        title: 'ÁO NỮ',
        href: '/collection/ao-nu',
        items: [
          { title: 'Áo Sport Bra', href: '/collection/ao-bra-nu' },
          { title: 'Áo Croptop', href: '/collection/ao-cropped-top' },
          { title: 'Áo Polo', href: '/collection/ao-polo-nu' },
          { title: 'Áo Singlet', href: '/collection/ao-singlet-nu' },
          { title: 'Áo Thun', href: '/collection/ao-thun-nu' },
          { title: 'Áo thun Graphic', href: '/graphic-tee?itm_source=navbar' },
        ],
      },
      {
        title: 'QUẦN NỮ',
        href: '/collection/quan-nu',
        items: [
          { title: 'Quần Legging', href: '/collection/quan-legging' },
          { title: 'Quần Shorts', href: '/collection/quan-short-nu' },
          { title: 'Quần Biker Shorts', href: '/collection/quan-biker-short' },
          { title: 'Váy - Đầm', href: '/collection/vay-dam-nu' },
        ],
      },
      {
        title: 'PHỤ KIỆN',
        href: '/collection/phu-kien-nu',
        items: [
          {
            title: 'Tất cả phụ kiện',
            description: '(Tất, mũ, túi...)',
            href: '/collection/phu-kien-nu',
          },
        ],
      },
      {
        title: 'KHÁM PHÁ',
        href: '',
        items: [
          {
            title: 'Hướng dẫn chọn Size nữ',
            href: '/huong-dan-chon-size-do-nu',
          },
          {
            title: 'Đại sứ của chúng tôi',
            href: '/dai-su-the-thao?active-tab=sports-ambassador',
          },
          {
            title: 'Câu lạc bộ đồng hành',
            href: '/dai-su-the-thao?active-tab=club-sports-ambassador',
          },
        ],
      },
    ],
    featured: [
      {
        title: 'Pickleball Nữ',
        href: '/collection/pickleball-tennis?danh-muc-san-pham=pickleball-nu',
        imageAlt: 'Pickleball Nữ',
        imageSrc: '/image/June2025/mceclip10_41.jpg',
      },
      {
        title: 'LEGGING YOGA RIBBED',
        href: '/collection/bra-legging-collection',
        imageAlt: 'LEGGING YOGA RIBBED',
        imageSrc: '/image/July2025/mceclip6_50.png',
      },
    ],
  },
}

export const navConfigCollection = {
  'Thể Thao': {
    href: '/collection/coolmate-activewear',
    sections: [
      {
        title: 'THỂ THAO NAM',
        href: '/collection/coolmate-activewear',
        items: [
          {
            title: 'Thể thao chung',
            href: '/collection/the-thao-chung-nam',
            img: '/image/March2025/mceclip22.png',
          },
          {
            title: 'Chạy bộ',
            href: '/collection/quan-ao-chay-bo',
            img: '/image/March2025/mceclip18_32.png',
          },
          {
            title: 'Tập gym',
            href: '/collection/quan-ao-phu-kien-tap-gym',
            img: '/image/March2025/mceclip19_2.png',
          },
          {
            title: 'Bóng đá',
            href: '/collection/quan-ao-da-bong-coolmate',
            img: '/image/March2025/mceclip16.png',
          },
          {
            title: 'Bơi lội',
            href: '/collection/do-boi-nam',
            img: '/image/March2025/mceclip15.png',
          },
          {
            title: 'Cầu lông & Bóng bàn',
            href: '/collection/racquet-sports-collection',
            img: '/image/March2025/mceclip17_87.png',
          },
          {
            title: 'Pickleball',
            href: '/collection/pickleball-tennis?danh-muc-san-pham=pickleball-nam',
            img: '/image/June2025/mceclip7.png',
          },
          {
            title: 'Outdoor',
            href: '/collection/outdoor-collection',
            img: '/image/August2024/mceclip0_18.jpg',
          },
        ],
      },
      {
        title: 'THỂ THAO NỮ',
        href: '/collection/coolmate-activewear-nu',
        items: [
          {
            title: 'Yoga & Pilates',
            href: '/collection/yoga-pilates',
            img: '/image/March2025/mceclip14.png',
          },
          {
            title: 'Áo thể thao nữ',
            href: '/collection/ao-nu-choi-the-thao',
            img: '/image/March2025/mceclip9_28.png',
          },
          {
            title: 'Chạy bộ',
            href: '/collection/quan-ao-chay-bo-nu',
            img: '/image/March2025/mceclip10_72.png',
          },
          {
            title: 'Quần thể thao nữ',
            href: '/collection/quan-nu-choi-the-thao',
            img: '/image/March2025/mceclip12_6.png',
          },
          {
            title: 'Thể thao chung',
            href: '/collection/the-thao-chung-nu',
            img: '/image/March2025/mceclip13_73.png',
          },
          {
            title: 'Phụ kiện thể thao nữ',
            href: '/collection/phu-kien-nu-choi-the-thao',
            img: '/image/March2025/mceclip11_21.png',
          },
          {
            title: 'Pickleball',
            href: '/collection/pickleball-tennis?danh-muc-san-pham=pickleball-nu',
            img: '/image/June2025/mceclip6_7.png',
          },
        ],
      },
    ],
    featured: [
      {
        title: 'Pickleball & Tennis',
        href: '/collection/pickleball-tennis',
        imageAlt: 'Pickleball & Tennis',
        imageSrc: '/image/June2025/mceclip11_92.jpg',
      },
      {
        title: 'Quần Shorts Nam Thể Thao Promax-S1',
        href: '/product/quan-the-thao-nam-promax-s1?color=den',
        imageAlt: 'Quần Shorts Nam Thể Thao Promax-S1',
        imageSrc: '/image/April2025/mceclip4_98.jpg',
      },
    ],
  },
}

export const navConfigCareAndShare = {
  title: 'CARE & SHARE',
  description:
    'Coolmate cam kết dành 10% doanh thu từ sản  phẩm “Care & Share” đóng góp vào quỹ để tổ chức các hoạt động thiện nguyện dành cho trẻ  em có hoàn cảnh khó khăn.',
  imageStep: '/image/September2024/mceclip7_1.png',
  href: '/collection/care-and-share',
  image: '/image/March2025/mceclip0_226.jpg',
  imageMobile: '/image/February2025/mceclip0_55.png',
  buttonText: 'CARE & SHARE',
  specialCollections: [
    {
      title: 'Áo ấm cho em',
      href: '/collection/ao-am-cho-em',
      img: '/image/October2024/mceclip0_9.png',
    },
    {
      title: 'Vụn Art',
      href: '/collection/vun-art-du-an-chung-tay-xay-nha-moi',
      img: '/image/July2024/mceclip0_156.jpg',
    },
    {
      title: 'Cung Hoàng Đạo',
      href: '/collection/cung-hoang-dao-collection',
      img: '/image/May2024/mceclip2_33.png',
    },
  ],
}

export const menuMobileConfig = {
  menu: {
    NAM: {
      button: {
        text: 'KHÁM phá đồ nam',
        href: '/nam',
      },
      sections: [
        {
          title: 'NỔI BẬT',
          items: [
            { title: 'Tất cả sản phẩm', href: '/collection/do-nam' },
            {
              title: 'Sản phẩm mới',
              href: '/collection/san-pham-moi?gender_type=MALE',
              className: 'text-primary',
            },
            {
              title: 'Bán chạy nhất',
              href: '/collection/ban-chay-nhat?gender_type=MALE',
              className: 'text-neutral-900',
            },
            { title: 'ECC Collection', href: '/collection/ecc-collection' },
            { title: 'Excool Collection', href: '/collection/excool' },
            { title: 'Copper Denim', href: '/collection/copper-denim' },
            { title: 'Promax', href: '/collection/ldp-promax' },
            {
              title: 'OUTLET -50%',
              href: '/collection/giam-gia',
              className: 'text-error-500',
            },
          ],
        },
        {
          title: 'ÁO NAM',
          items: [
            { title: 'Tất cả Áo nam', href: '/collection/ao-nam' },
            { title: 'Áo Tanktop', href: '/collection/ao-ba-lo-tank-top-nam' },
            { title: 'Áo Thun', href: '/collection/ao-thun-nam' },
            {
              title: 'Áo Thể Thao',
              href: '/collection/ao-nam-choi-the-thao',
            },
            { title: 'Áo Polo', href: '/collection/ao-polo-nam' },
            { title: 'Áo Sơ Mi', href: '/collection/ao-so-mi-nam' },
            { title: 'Áo Dài Tay', href: '/collection/ao-nam-dai-tay' },
            { title: 'Áo Khoác', href: '/collection/ao-khoac-nam' },
            {
              title: 'Graphics Tees',
              href: '/graphic-tee',
            },
          ],
        },
        {
          title: 'QUẦN NAM',
          items: [
            { title: 'Tất cả Quần nam', href: '/collection/quan-nam' },
            { title: 'Quần Shorts', href: '/collection/quan-short-nam' },
            { title: 'Quần Jogger', href: '/collection/quan-jogger-nam' },
            {
              title: 'Quần Thể Thao',
              href: '/collection/quan-nam-choi-the-thao',
            },
            { title: 'Quần Dài', href: '/collection/quan-dai-nam' },
            { title: 'Quần Jean', href: '/collection/quan-jeans-nam' },
            { title: 'Quần Kaki', href: '/collection/quan-kaki-nam' },
            { title: 'Quần Pants', href: '/collection/quan-pants-nam' },
            { title: 'Quần Bơi', href: '/collection/do-boi-nam' },
          ],
        },
        {
          title: 'QUẦN LÓT NAM',
          items: [
            { title: 'Tất cả Quần lót nam', href: '/collection/quan-lot-nam' },
            {
              title: 'Brief (Tam giác)',
              href: '/collection/quan-lot-nam-brief-tam-giac',
            },
            {
              title: 'Trunk (Boxer)',
              href: '/collection/quan-lot-nam-boxer-trunk',
            },
            {
              title: 'Brief (Boxer Dài)',
              href: '/collection/quan-lot-nam-brief-boxer-dang-dai',
            },
            { title: 'Long leg', href: '/collection/quan-lot-nam-long-leg' },
            {
              title: 'Short mặc nhà',
              href: '/collection/quan-lot-nam-boxer-shorts',
            },
          ],
        },
        {
          title: 'PHỤ KIỆN',
          items: [
            {
              title: 'Tất cả phụ kiện',
              subtitle: '(Tất, mũ, túi...)',
              href: '/collection/phu-kien-nam',
            },
          ],
        },
      ],
      featured: [
        {
          title: 'Áo Sơ Mi Dài Tay Essentials Cotton',
          href: '/product/ao-so-mi-essentials-100-cotton-dai-tay-mem-mai2?color=trang',
          imageAlt: 'sadasd',
          imageSrc: '/image/March2025/mceclip24.png',
        },
        {
          title: 'Quần Jogger Nam UT',
          href: '/product/quan-jeans-nam-dang-straight-sieu-nhe?color=xanh-wash',
          imageAlt: 'sadasd',
          imageSrc: '/image/March2025/mceclip23.png',
        },
      ],
    },
    NỮ: {
      button: {
        text: 'KHÁM phá đồ nữ',
        href: '/nu',
      },
      sections: [
        {
          title: 'NỔI BẬT',
          items: [
            {
              title: 'Tất cả sản phẩm',
              href: '/collection/coolmate-activewear-nu',
            },
            {
              title: 'Chạy bộ',
              href: '/collection/quan-ao-chay-bo-nu',
              className: 'text-primary',
            },
            { title: 'Yoga & Pilates', href: '/collection/yoga-pilates' },
            { title: 'Thể thao chung', href: '/collection/the-thao-chung-nu' },
            {
              title: 'Pickleball',
              href: '/collection/pickleball-tennis?danh-muc-san-pham=pickleball-nu',
            },
            {
              title: 'Cầu lông & Bóng bàn (Coming soon)',
              href: '/collection/cau-long-bong-ban-nu',
              isComingSoon: true,
            },
          ],
        },
        {
          title: 'ÁO NỮ',
          items: [
            { title: 'Tất cả Áo nữ', href: '/collection/ao-nu' },
            { title: 'Áo Sport Bra', href: '/collection/ao-bra-nu' },
            { title: 'Áo Croptop', href: '/collection/ao-cropped-top' },
            { title: 'Áo Singlet', href: '/collection/ao-singlet-nu' },
            { title: 'Áo Thun', href: '/collection/ao-thun-nu' },
            {
              title: 'Graphics Tees',
              href: '/graphic-tee',
            },
          ],
        },
        {
          title: 'QUẦN NỮ',
          items: [
            { title: 'Tất cả Quần nữ', href: '/collection/quan-nu' },
            { title: 'Quần Legging', href: '/collection/quan-legging' },
            { title: 'Quần Shorts', href: '/collection/quan-short-nu' },
            {
              title: 'Quần Biker Shorts',
              href: '/collection/quan-biker-short',
            },
          ],
        },
        {
          title: 'PHỤ KIỆN',
          items: [
            {
              title: 'Tất cả phụ kiện',
              subtitle: '(Tất, mũ, túi...)',
              href: '/collection/phu-kien-nu',
            },
          ],
        },
        {
          title: 'KHÁM PHÁ',
          items: [
            {
              title: 'Hướng dẫn chọn Size nữ',
              href: '/huong-dan-chon-size-do-nu',
            },
            {
              title: 'Đại sứ của chúng tôi',
              href: '/dai-su-the-thao?active-tab=sports-ambassador',
            },
            {
              title: 'Câu lạc bộ đồng hành',
              href: '/dai-su-the-thao?active-tab=club-sports-ambassador',
            },
          ],
        },
      ],
      featured: [
        {
          title: 'COOLMATE ACTIVE FOR WOMEN',
          href: '/collection/coolmate-activewear-nu',
          imageAlt: 'COOLMATE ACTIVE FOR WOMEN',
          imageSrc: '/image/March2025/mceclip30.png',
        },
        {
          title: 'LEGGING YOGA RIBBED',
          href: '/collection/bra-legging-collection',
          imageAlt: 'LEGGING YOGA RIBBED',
          imageSrc: '/image/July2025/mceclip5_40.png',
        },
      ],
    },
    'THỂ THAO': {
      button: undefined,
      sections: [
        {
          title: 'THỂ THAO NAM',
          items: [
            {
              title: 'Thể thao chung',
              href: '/collection/the-thao-chung-nam',
              img: '/image/March2025/mceclip22.png',
            },
            {
              title: 'Chạy bộ',
              href: '/collection/quan-ao-chay-bo',
              img: '/image/March2025/mceclip18_32.png',
            },
            {
              title: 'Tập gym',
              href: '/collection/quan-ao-phu-kien-tap-gym',
              img: '/image/March2025/mceclip19_2.png',
            },
            {
              title: 'Bóng đá',
              href: '/collection/quan-ao-da-bong-coolmate',
              img: '/image/March2025/mceclip16.png',
            },
            {
              title: 'Bơi lội',
              href: '/collection/do-boi-nam',
              img: '/image/March2025/mceclip15.png',
            },
            {
              title: 'Cầu lông & Bóng bàn',
              href: '/collection/racquet-sports-collection',
              img: '/image/March2025/mceclip17_87.png',
            },
            {
              title: 'Pickleball & Tennis',
              href: '/collection/pickleball-tennis?danh-muc-san-pham=pickleball-nam',
              img: '/image/June2025/mceclip7.png',
            },
            {
              title: 'Outdoor',
              href: '/collection/outdoor-collection',
              img: '/image/August2024/mceclip0_18.jpg',
            },
          ],
        },
        {
          title: 'THỂ THAO NỮ',
          items: [
            {
              title: 'Yoga & Pilates',
              href: '/collection/yoga-pilates',
              img: '/image/March2025/mceclip14.png',
            },
            {
              title: 'Áo thể thao nữ',
              href: '/collection/ao-nu-choi-the-thao',
              img: '/image/March2025/mceclip9_28.png',
            },
            {
              title: 'Chạy bộ',
              href: '/collection/quan-ao-chay-bo-nu',
              img: '/image/March2025/mceclip10_72.png',
            },
            {
              title: 'Quần thể thao nữ',
              href: '/collection/quan-nu-choi-the-thao',
              img: '/image/March2025/mceclip12_6.png',
            },
            {
              title: 'Thể thao chung',
              href: '/collection/the-thao-chung-nu',
              img: '/image/March2025/mceclip13_73.png',
            },
            {
              title: 'Phụ kiện thể thao nữ',
              href: '/collection/phu-kien-nu-choi-the-thao',
              img: '/image/March2025/mceclip11_21.png',
            },
            {
              title: 'Pickleball',
              href: '/collection/pickleball-tennis?danh-muc-san-pham=pickleball-nu',
              img: '/image/June2025/mceclip6_7.png',
            },
          ],
        },
      ],
      featured: [
        {
          title: 'Áo Polo Nam Thể Thao Promax-S1',
          href: '/product/ao-polo-the-thao-nam-promax-s1-logo-1?color=nau-coffee-quartz',
          imageAlt: 'Áo Polo Nam Thể Thao Promax-S1',
          imageSrc: '/uploads/April2025/mceclip6_98.jpg',
        },
        {
          title: 'Quần Shorts Nam Thể Thao Promax-S1',
          href: '/product/quan-the-thao-nam-promax-s1?color=den',
          imageAlt: 'Quần Shorts Nam Thể Thao Promax-S1',
          imageSrc: '/uploads/April2025/mceclip3_42.jpg',
        },
      ],
    },
  },
  footer: {
    menu: [
      {
        title: 'CoolClub',
        icon: Star,
        className: 'font-bold text-primary-500 [&_svg]:fill-primary-500',
        href: '/page/coolclub-chuong-trinh-khach-hang-than-thiet-cua-coolmate',
      },
      {
        title: 'Trung tâm CSKH',
        href: '/page/trung-tam-dich-vu-khach-hang?itm_source=navbar',
      },
      {
        title: 'Về Coolmate',
        href: '/page/coolmate-story',
      },
      {
        title: 'Tuyển dụng',
        href: '/lp/coolmate-101?itm_source=footer',
      },
      {
        title: 'Đăng nhập',
        href: '/login',
      },
      {
        title: 'Blog',
        href: '/blog',
      },
    ],
  },
}
